import { render, staticRenderFns } from "./editResource.vue?vue&type=template&id=f63bbaf6"
import script from "./editResource.vue?vue&type=script&lang=js"
export * from "./editResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports